import { createSlice } from '@reduxjs/toolkit';

const reducerName = 'atsApplication';
const initialState = {
  notes: { data: [], meta: {} },
};

const { reducer, actions: atsApplicationActions } = createSlice({
  name: reducerName,
  initialState,

  reducers: {
    addApplicationNotes: (state, { payload }) => {
      const { notes = [], meta = null, isInitial = false } = payload;
      if (isInitial) {
        state.notes.data = [...notes]?.reverse();
        state.notes.meta = meta;
      } else {
        state.notes.data = [...[...notes]?.reverse(), ...state?.notes?.data];
        state.notes.meta = meta;
      }
    },

    addApplicationNote: (state, { payload }) => {
      const { newNote } = payload;
      state.notes.data =
        state?.notes?.data?.length > 0
          ? [...state?.notes?.data, newNote]
          : [newNote];
      state.notes.meta = {
        ...state.notes.meta,
        count: (state?.notes?.meta?.count || 0) + 1,
      };
    },

    updateApplicationNote: (state, { payload }) => {
      const { note, newNote } = payload;
      state.notes.data = state?.notes?.data?.map?.((item) => {
        if (item?.id === note?.id) return newNote;
        else return item;
      });
    },
  },
});

export { atsApplicationActions };
export default reducer;
